import React from "react";
import {
  MenuItem,
  FormControl,
  OutlinedInput,
} from "@mui/material";
import { GrFormClose} from "react-icons/gr";
import {
  SelectMenu,
  StyledMenu,
  StyledMUISelect,
} from "../styled/StyledSelect.styled";
import Autocomplete from "@mui/material/Autocomplete";

export default function StyledDataSelect({
  label,
  defaultVal,
  options,
  control,
  setControl,
  helperText,
  disabled,
  enableCloseWhenDisabled = false,
  ...props
}) {
  const handleChange = (e) => {
    setControl(e.target.value);
  };
  return (
    <div>
      <FormControl variant="standard" sx={{ width: "100%" }}>
        {control === "init"? (
          <StyledMUISelect
          {...props}
          small
          variant="outlined"
          labelId={label}
          id={label}
          renderValue={(selected) => {
            if (selected === "init")
              return <StyledMenu small>{defaultVal}</StyledMenu>;
            return <SelectMenu small>{selected}</SelectMenu>;
          }}
          sx={{ height: "30px" }}
          onChange={handleChange}
          input={<OutlinedInput />}
          label={label}
          value={control}
          disabled={disabled}
          style={{ marginTop: "0px" }}
          >
          {options?.map((option, index) => {
            return (
              <MenuItem
                sx={{ textTransform: "capitalize" }}
                key={index}
                value={option.value || option.label || option}
                style={{maxHeight:"300px"}}
              >
                {option.label || option}
              </MenuItem>
            );
          })}
        </StyledMUISelect>
        ):(<StyledMUISelect
          {...props}
          small
          variant="standard"
          labelId={label}
          id={label}
          renderValue={(selected) => {
            if (selected === "init")
              return <StyledMenu small>{defaultVal}</StyledMenu>;
            return <SelectMenu small>{selected}</SelectMenu>;
          }}
          sx={{ height: "30px" }}
          onChange={handleChange}
          input={<OutlinedInput />}
          label={label}
          value={control}
          style={{ marginTop: "0px" }}
          disabled={disabled}
          IconComponent={
           ()=>{return <GrFormClose data-testid="gr-form-close-styled" style={{
            cursor: "pointer",
            position: "absolute",
            right: "7px",
            top: "calc(50% - 0.5em)",
            color: "rgba(0,0,0,0.54)"
             }}
              onClick={()=>{
                if(enableCloseWhenDisabled || !disabled){
                  setControl("init")
                }
                }}/>}}
        >
          {options?.map((option, index) => {
            return (
              <MenuItem
                sx={{ textTransform: "capitalize" }}
                key={index}
                value={option.value || option.label || option}
                style={{maxHeight:"300px"}}
              >
               
                {option.label || option}
              </MenuItem>
            );
          })}
        </StyledMUISelect>)}
      </FormControl>
    </div>
  );
}
